// /******/ (function() { // webpackBootstrap
// /******/ 	"use strict";
// var __webpack_exports__ = {};
// // extracted by mini-css-extract-plugin

// /******/ })()
// ;

if (!customElements.get("m-scrolling-promotion")) {
    class e extends HTMLElement {
        constructor() {
            super()
        }
        connectedCallback() {
            this.promotion = this.querySelector(".m-promotion"), this.init()
        }
        init() {
            if (1 === this.childElementCount) {
                this.promotion.classList.add("m-promotion--animated");
                for (let e = 0; e < 10; e++) this.clone = this.promotion.cloneNode(!0), this.clone.setAttribute("aria-hidden", !0), this.appendChild(this.clone);
                new IntersectionObserver(((e, t) => {
                    e.forEach((e => {
                        e.isIntersecting ? this.scrollingPlay() : this.scrollingPause()
                    }))
                }), {
                    rootMargin: "0px 0px 50px 0px"
                }).observe(this)
            }
        }
        scrollingPlay() {
            this.classList.remove("m-scrolling-promotion--paused")
        }
        scrollingPause() {
            this.classList.add("m-scrolling-promotion--paused")
        }
    }
    customElements.define("m-scrolling-promotion", e)
}